"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPACEBAR_KEY = exports.ENTER_KEY = exports.ESC_KEY = void 0;
var ESC_KEY = 27;
exports.ESC_KEY = ESC_KEY;
var ENTER_KEY = 13;
exports.ENTER_KEY = ENTER_KEY;
var SPACEBAR_KEY = 32;
exports.SPACEBAR_KEY = SPACEBAR_KEY;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/util/keyCodes.js
// module id = 229
// module chunks = 0